module.exports = __webpack_public_path__ + "img/bullet.05eaa856.svg";